//左上アイコンをクリック時の処理
window.addEventListener('DOMContentLoaded', function(){
    let navbar_bars_input = document.getElementById('navbar_bars_input');
    navbar_bars_input.addEventListener("change",function(){
        let side_menu = document.getElementById('side_menu');
        let main_contents = document.getElementById('main_contents');
        let alert_org = document.getElementById('alert_org');
        if (navbar_bars_input.checked) { //PC メニュー非表示化 スマホ メニュー表示
                side_menu.classList.replace('side_menu', 'side_menu_hide');
                main_contents.classList.replace('main_contents', 'main_contents_wide');
                if (alert_org !== null){
                    alert_org.classList.replace('alert_org', 'alert_org_wide');
                }
            } else { //PC メニュー非表示化 スマホ メニュー表示
                side_menu.classList.replace('side_menu_hide', 'side_menu');
                main_contents.classList.replace('main_contents_wide', 'main_contents');
                if (alert_org !== null){
                    alert_org.classList.replace('alert_org_wide', 'alert_org');
                }
            }
        }
    );
});

$(document).on({
    'mouseenter':function(){
        let text = $(this).attr('data-text');
        $(this).append('<p class="menu_tooltip">'+text+'</p>');
    },
    'mouseleave':function(){
        $(this).find(".menu_tooltip").remove();
    }
}, "#side_menu li.child");

//スマホ時にメニュー外をクリック時にメニューを閉じる処理
document.addEventListener('click', (e) => {
    let navbar_bars_input = document.getElementById('navbar_bars_input');
    if(!e.target.closest('.side_menu_hide') & !e.target.closest('.navbar') & window.matchMedia('(max-width:1024px)').matches) {
        if (navbar_bars_input.checked) {
            navbar_bars_input.checked = false;
            let side_menu = document.getElementById('side_menu');
            let main_contents = document.getElementById('main_contents');
            side_menu.classList.replace('side_menu_hide', 'side_menu');
            main_contents.classList.replace('main_contents_wide', 'main_contents');
        }
    }
})